var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9995 11.6675H19.5195C19.0825 11.6665 18.6572 11.8088 18.3086 12.0724C17.9601 12.3361 17.7075 12.7067 17.5895 13.1275L15.2395 21.4875C15.2244 21.5394 15.1928 21.585 15.1495 21.6175C15.1062 21.6499 15.0536 21.6675 14.9995 21.6675C14.9454 21.6675 14.8928 21.6499 14.8495 21.6175C14.8062 21.585 14.7747 21.5394 14.7595 21.4875L9.23951 1.84748C9.22437 1.79555 9.19279 1.74994 9.14951 1.71748C9.10624 1.68502 9.0536 1.66748 8.99951 1.66748C8.94542 1.66748 8.89279 1.68502 8.84951 1.71748C8.80624 1.74994 8.77466 1.79555 8.75951 1.84748L6.40951 10.2075C6.29198 10.6266 6.04089 10.996 5.69438 11.2595C5.34786 11.523 4.92483 11.6662 4.48951 11.6675H1.99951",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.80cce0b83660278f5766c42adbc74732.svg";
export { ForwardRef as ReactComponent };